import getSubscriptionPlanTrainingUserUtil
from 'modules/training/models/user/utils/get-subscription-plan'

function hasPremiumTrainingUserUtil (user) {
  return !!getSubscriptionPlanTrainingUserUtil(user)
}

export default hasPremiumTrainingUserUtil
